import { getCentrifugoToken } from '@/fsd/entities/notifications/api/getCentrifugoToken/getCentrifugoToken';
import NotificationService from '@/fsd/shared/lib/notifications/model/services/NotificationService/NotificationService';
import type { RealtimeNotification } from './types/RealtimeNotification';
import { useQueryClient } from '@tanstack/react-query';
import { Centrifuge } from 'centrifuge';
import { useEffect } from 'react';

export const useRealtimeNotifications = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    let disposed = false;
    let centrifuge: Centrifuge | null = null;

    const connect = async () => {
      try {
        const { token, channel } = await getCentrifugoToken();

        const host = process.env.API_DOMAIN;

        if (disposed) return;

        centrifuge = new Centrifuge(
          [
            {
              transport: 'websocket',
              endpoint: `wss://${host}/connection/websocket`,
            },
            {
              transport: 'sse',
              endpoint: `https://${host}/connection/sse`,
            },
          ],
          {
            token,
            getToken: async () => {
              const result = await getCentrifugoToken();
              return result.token;
            },
          }
        );

        const subscription = centrifuge.newSubscription(channel);

        subscription.on('publication', (ctx) => {
          const notification = ctx.data as RealtimeNotification;

          if (notification.event !== 'notification.created') {
            return;
          }

          NotificationService.success({
            title: notification.title || 'Новое уведомление',
            message: notification.message || 'Получено новое уведомление',
          });

          console.log('[Centrifugo] Новое уведомление:', notification);

          void Promise.all([
            queryClient.refetchQueries({
              queryKey: ['notifications'],
              type: 'all',
            }),
            queryClient.refetchQueries({
              queryKey: ['notification-count'],
              type: 'all',
            }),
          ]);
        });

        subscription.on('subscribed', () => {
          console.log('[Centrifugo] Подписка активна:', channel);
        });

        subscription.on('error', (ctx) => {
          console.error('[Centrifugo] Ошибка подписки:', ctx);
        });

        centrifuge.on('connected', (ctx) => {
          console.log('[Centrifugo] Подключено:', ctx);
        });

        centrifuge.on('disconnected', (ctx) => {
          console.log('[Centrifugo] Соединение закрыто:', ctx);
        });

        subscription.subscribe();
        centrifuge.connect();
      } catch (error) {
        console.error('[Centrifugo] Ошибка подключения:', error);
      }
    };

    void connect();

    return () => {
      disposed = true;
      centrifuge?.disconnect();
    };
  }, [queryClient]);
};